module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/balcony/balcony.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/balcony/balcony.png
// module id = 514
// module chunks = 0